module.exports = __webpack_public_path__ + "static/media/background.58f55ee6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/background.jpg
// module id = 2210
// module chunks = 0